import React from 'react';
import moment from 'moment';
import PropTypes from 'prop-types';
import DatePicker from 'react-datepicker';
import { addBusinessDays, subBusinessDays } from 'date-fns';
import { Calendar } from '@tds/core-decorative-icon';

import { DateWrapper } from '../../filters/css';
import { getFormattedDate } from '../../utils/utils';
import 'react-datepicker/dist/react-datepicker.css';
import { FieldLabelWrapper, FieldWrapper } from './css';
import FieldGuide from './common/fieldGuide';
import FieldTitle from './common/FieldTitle';
import { fieldPreferredInstallationDate } from '../../utils/constant';

const FieldDate = ({ data, orderData }) => {
  const {
    value,
    placeholder,
    label,
    onChange,
    name,
    required,
    fieldDateConfig,
    readonly,
    tooltip,
    tooltipLong,
    toolTipRichText
  } = data;

  const config = {};
  if (typeof fieldDateConfig.minDays !== 'undefined') {
    config.minDate = subBusinessDays(new Date(), fieldDateConfig.minDays);
  }
  if (typeof fieldDateConfig.maxDays !== 'undefined') {
    config.maxDate = addBusinessDays(new Date(), fieldDateConfig.maxDays);
  }

  /**
   * Rule: Preferred Installation should be more then 15 business days
   * from the order creation date
   */
  if (name === fieldPreferredInstallationDate) {
    config.minDate = addBusinessDays(new Date(orderData.createdAt), 15);
  }
  const tooltipMessage = tooltip || tooltipLong || toolTipRichText;
  return (
    <FieldWrapper>
      <div>
        <FieldLabelWrapper>
          <FieldTitle required={required} label={label} />
          {tooltipMessage && (
            <FieldGuide tooltip={tooltipMessage} isRichText={toolTipRichText} />
          )}
        </FieldLabelWrapper>
      </div>
      <DateWrapper width="100%" position="relative">
        <DatePicker
          {...config}
          popperPlacement="top-start"
          disabled={readonly}
          dateFormat="yyyy/MM/dd"
          placeholderText={placeholder}
          selected={value && moment(value).toDate()}
          onChange={dateValue => {
            onChange({
              target: {
                name,
                value: getFormattedDate(
                  dateValue === 'Invalid date' ? '' : dateValue
                )
              }
            });
          }}
        />
        <div style={{ position: 'absolute', top: '0.7rem', right: '0.7rem' }}>
          <Calendar variant="default" size={24} />
        </div>
      </DateWrapper>
    </FieldWrapper>
  );
};

FieldDate.propTypes = {
  orderData: PropTypes.objectOf(PropTypes.any).isRequired,
  data: PropTypes.shape({
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.instanceOf(Date)]),
    name: PropTypes.string.isRequired,
    placeholder: PropTypes.string,
    label: PropTypes.string,
    required: PropTypes.bool,
    onChange: PropTypes.func.isRequired,
    fieldDateConfig: PropTypes.shape({
      minDays: PropTypes.number,
      maxDays: PropTypes.number
    }),
    readonly: PropTypes.bool,
    tooltip: PropTypes.string,
    tooltipLong: PropTypes.string,
    toolTipRichText: PropTypes.shape({
      content: PropTypes.arrayOf(PropTypes.object)
    })
  }).isRequired
};

export default FieldDate;
